import React, { Children, cloneElement } from 'react'

import useResizeObserver from 'effects/useResizeObserver';


export const sized = (WrappedComponent) => props =>
  <SizedComponent>
    {/* inject a dummy size in case of proptype requirements that will warn during this unseen render */}
    <WrappedComponent size={{ width: 0, height: 0 }} { ...props }/>
  </SizedComponent>

const SizedComponent = ({ children }) => {
  const [ ref, size ] = useResizeObserver()

  return (
    <div ref={ ref } style={{ width: '100%', height: '100%' }}>
      {Children.map(children, child =>
        cloneElement(child, { size }) // copy of the child with the size prop added/overidden
      )}
    </div>
  )
}

export default SizedComponent
